export default __webpack_public_path__ + "static/media/celular-super-bonder.339214fe.png";